import EnhancedSider from './container/index';

export default EnhancedSider;



// WEBPACK FOOTER //
// ./src/components/page/EnhancedSider/index.js